import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { io } from "socket.io-client";

// Cria o contexto
const ProductContext = createContext();

// URL do backend e Socket.IO
const SOCKET_URL = "https://cardapio.olympicbarbacena.com.br";


// Provider para gerenciar e compartilhar dados
export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);  
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({ cover: "", logo: "" });

  useEffect(() => {
    // Função para buscar os dados iniciais
    const fetchData = async () => {
      try {
        const [productsRes, categoriesRes, settingsRes] = await Promise.all([
          axios.get(`${SOCKET_URL}/api/produtos`),
          axios.get(`${SOCKET_URL}/api/categories`),
          axios.get(`${SOCKET_URL}/api/settings`)          

        ]);
        setProducts(productsRes.data);
        setCategories(categoriesRes.data);
        setSettings(settingsRes.data);
        
      } catch (error) {
        console.error("Erro ao buscar dados iniciais:", error);
      } finally {
        setLoading(false);
      }
    };

    // Chamada inicial
    fetchData();

    // Configurar o Socket.IO
    const socket = io(SOCKET_URL);

    // Atualizações de produtos
    socket.on("update", ({ type, action, data }) => {
      if (type === "product") {
        if (action === "added") {
          setProducts((prev) => [...prev, data]);
        } else if (action === "updated") {
          setProducts((prev) =>
            prev.map((item) => (item._id === data._id ? { ...item, ...data } : item))
          );
        } else if (action === "deleted") {
          setProducts((prev) => prev.filter((item) => item._id !== data.id));
        }
      }
      if (type === "category") {
        if (action === "added") {
            setCategories((prev) => [...prev, data]);
          } else if (action === "updated") {
            setCategories((prev) =>
              prev.map((item) => (item._id === data._id ? { ...item, ...data } : item))
            );
          } else if (action === "deleted") {
            setCategories((prev) => prev.filter((item) => item._id !== data.id));
          }
      }

      if (type === "settings") {
        if (action === "added") {
            setSettings((prev) => [...prev, data]);
          } else if (action === "updated") {
            setSettings((prev) =>
              prev.map((item) => (item._id === data._id ? { ...item, ...data } : item))
            );
          } else if (action === "deleted") {
            setSettings((prev) => prev.filter((item) => item._id !== data.id));
          }
      }
    });


    // Atualizações de usuários online
    socket.on("updateOnlineConnections", (connections) => {
      setOnlineUsers(connections);
    });

    // Limpeza ao desmontar
    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <ProductContext.Provider
      value={{
        products,
        categories,        
        onlineUsers,
        setProducts,
        setCategories,        
        loading,
        settings
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export default ProductContext;
